export default __webpack_public_path__ + "static/media/GeoffreyJones.39abfa88.png";